export enum GroupTypesEnum {
   BusinessUnit,
   Betshop,
   Manager,
   Cashier,
   Partner,
   Game
}